// Module
var code = "<span class=\"panel-row-required\" data-tooltip=\"{{ 'TR_090119-2705b2_TR' | translate }}\">*</span> ";
// Exports
module.exports = code;